// LE MUR DE CONNEXION — revenir là où l'on était, et compter combien de fois on s'y heurte.
//
// 10/10/2026 — audit d'acquisition (lot E1, score 12,0) : sur la fiche annonce, six
// boutons envoyaient un visiteur non connecté vers /login SANS mémoriser la page
// (« Connectez-vous pour contacter », « … pour louer / réserver », l'offre, la veille de
// disponibilité, la conversation) : après la connexion, il atterrissait sur son profil
// et devait retrouver l'annonce. Seul « Se connecter pour acheter » revenait.
// Et personne ne savait combien de visiteurs se heurtaient à ce mur, ni sur quel bouton.
//
// Une seule porte désormais : `allerSeConnecter(navigate, cible)` mémorise la page
// (`gively_return_to`, déjà relu par LoginPage et le retour OAuth d'App.js), laisse
// UNE balise anonyme `MUR_CONNEXION` (ligne [ACTIVITE] mur_connexion côté serveur,
// routes/checkout_quote.py) et ouvre la connexion. La balise ne porte ni identité ni
// texte saisi : la cible (liste fermée ci-dessous) et le chemin de la page.

import { API_URL } from "../config/backend";

export const CLE_RETOUR = "gively_return_to";

// Liste fermée, identique côté serveur (CIBLES_MUR_CONNEXION) : tout autre mot est
// journalisé « autre ».
export const CIBLES_MUR = Object.freeze([
  "acheter", "contacter", "offre", "louer", "reserver", "veille", "message", "page_protegee",
]);

export function cheminCourant() {
  try {
    return window.location.pathname + window.location.search;
  } catch (_) {
    return "";
  }
}

export function memoriserRetour(chemin = cheminCourant()) {
  try {
    if (chemin && chemin.startsWith("/") && !chemin.startsWith("//") && chemin !== "/login") {
      sessionStorage.setItem(CLE_RETOUR, chemin);
    }
  } catch (_) { /* navigation privée : on ouvre la connexion quand même */ }
}

export function signalerMurConnexion(cible) {
  try {
    const page = (window.location.pathname || "").slice(0, 120);
    const corps = JSON.stringify({
      event: "MUR_CONNEXION",
      message: CIBLES_MUR.includes(cible) ? cible : "autre",
      extra: { page },
    });
    navigator.sendBeacon(`${API_URL}/telemetry/frontend-log`, new Blob([corps], { type: "application/json" }));
  } catch (_) { /* un journal ne bloque jamais la navigation */ }
}

export function allerSeConnecter(navigate, cible) {
  memoriserRetour();
  signalerMurConnexion(cible);
  navigate("/login");
}
